/* eslint-disable */
//tslint:disable

import { IUserAvailableServicesSchema } from './UserAvailableServicesSchema';
import { IMasterAgentSchema } from './MasterAgentSchema';
import { IAgentMetricSchema } from './AgentMetricSchema';
import { IAgentModerationInfoSchema } from './AgentModerationInfoSchema';
import { IAgentPhoneSchema } from './AgentPhoneSchema';
import { IAgentSkillSchema } from './AgentSkillSchema';

export interface IAgentSchema {
  /** Аватар заданный агентом в настройках ЛК **/
  absoluteAvatarUrl?: string | null;
  /** Мини аватар заданный агентом в настройках ЛК **/
  absoluteMiniAvatarUrl?: string | null;
  /** Тип аккаунта **/
  accountType?: EAccountType | null;
  /** Признаки объявлений (ЭТП, Залоговая, Аукцион) **/
  agentLists?: string[] | null;
  /** Доступные сервисы для пользователя **/
  availableServices?: IUserAvailableServicesSchema | null;
  /** Банк, к которому привязан агент **/
  bank?: string | null;
  /** Онлайн показ **/
  canShowOnline?: boolean | null;
  /** ID пользователя на ЦИАНе **/
  cianUserId?: number | null;
  /** Место работы, если тип агента специалист **/
  companyName?: string | null;
  /** Время регистрации на циан **/
  creationDate?: string | null;
  /** "обо мне" профиля агента **/
  description?: string | null;
  /** Опыт работы **/
  experience?: string | null;
  /** Имя **/
  firstName?: string | null;
  /** Идентификатор **/
  id?: number | null;
  /** Партнёр ЦИАН **/
  isCianPartner?: boolean | null;
  /** Является застройщиком **/
  isDeveloper?: boolean | null;
  /** Профиль скрыт **/
  isHidden?: boolean | null;
  /** Агент разрешил подавать заявки на просмотры объекта **/
  isMessagingEnabled?: boolean | null;
  /** Пользователь прошел верификацию по паспорту **/
  isPassportVerified?: boolean | null;
  /** Агент является частным маклером **/
  isPrivateBroker?: boolean | null;
  /** Профессионал **/
  isPro?: boolean | null;
  /** Флаг пессимизации, рецидивист **/
  isRecidivist?: boolean | null;
  /** Пользователь самозанятый(проверен в ФНС) **/
  isSelfEmployed?: boolean | null;
  /** Является сабагентом **/
  isSubAgent?: boolean | null;
  /** Флаг пессимизации, в объявлениях пользователя встречаются ошибки **/
  isUserOffersHasErrors?: boolean | null;
  /** Фамилия **/
  lastName?: string | null;
  /** Мастер агент **/
  masterAgent?: IMasterAgentSchema | null;
  /** Метрики агента **/
  metrics?: IAgentMetricSchema[] | null;
  /** Информация от модерации **/
  moderationInfo?: IAgentModerationInfoSchema | null;
  /** Имя специалиста или название агентства **/
  name?: string | null;
  /** Количество офферов агента **/
  offersCount?: number | null;
  /** Ссылка на все объявления пользователя **/
  offersLink?: string | null;
  /** Cian ID мастер-агента **/
  parentCianId?: number | null;
  /** ID мастер-агента **/
  parentId?: number | null;
  /** Список телефонов **/
  phones?: IAgentPhoneSchema[] | null;
  /** ID пользователя на Realty **/
  realtyUserId?: number | null;
  /** Опция удалить конкурента **/
  removeCompetitor?: boolean | null;
  /** Список специализаций **/
  skills?: IAgentSkillSchema[] | null;
  /** Статус публикации **/
  status?: EStatus | null;
  /** Тип пользователя для google аналитики **/
  userType?: string | null;
}

export enum EAccountType {
  /** Агенство **/
  Agency = 'agency',
  /** Управляющая компания **/
  ManagementCompany = 'managementCompany',
  /** Отдел аренды **/
  RentDepartment = 'rentDepartment',
  /** Специалист **/
  Specialist = 'specialist',
}
export enum EStatus {
  /** Скрыто **/
  Hidden = 'hidden',
  /** Опубликовано **/
  Published = 'published',
}
